// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"53463e39","143":"b9ad8c2c","941":"bfd527b6"}[chunkId] + ".css";
};